import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Common_Button.css";

const Common_Button = ({
  text = "Submit",
  icon,
  type = "button",
  className = "",
  onClick,
}) => {
  return (
    <button
      type={type}
      className={`common_button ${className}`}
      onClick={onClick}
    >
      {icon && <FontAwesomeIcon icon={icon} />}
      {text}
    </button>
  );
};

export default Common_Button;
